// Adapter to UniCloud: i18n-cloud.appspot.com
// @ts-expect-error
import CharPickerData from 'char-picker-data';
import $ from 'jquery';
import React from 'react';

import * as logging from 'util/Logging';
import * as net from 'util/Net';

const UNICLOUD_PROPERTIES_ENDPOINT = '/1/api/uni-cloud/cproperties';
const UNICLOUD_SEARCH_ENDPOINT = '/1/api/uni-cloud/csearch';

interface UniCloudResponse {
  [key: string]: {
    name: string;
  };
}

interface UniCloudRenderProps {
  name: string | undefined;
  codePoint: string;
}

interface UniCloudProps {
  char: string;
  children: (props: UniCloudRenderProps) => React.ReactNode;
}

interface UniCloudState {
  name: string | undefined;
}

let wasCalled = false;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function notifyUnicloudError(resp: any, endpoint: string, params: unknown): void {
  if (wasCalled) {
    // Disable after initial call
    return;
  }
  wasCalled = true;
  logging.error(
    `UniCloud: request to endpoint ${endpoint}?${$.param(params)} failed with error code ${resp.status}`
  );
}

class UniCloud extends React.PureComponent<UniCloudProps, UniCloudState> {
  static _queryEndpoint(endpoint: string, params: object): Promise<UniCloudResponse> {
    return net.getJSONPromise(endpoint, params).catch((resp) => {
      // Warn us and forward the error.
      notifyUnicloudError(resp, endpoint, params);
      throw resp;
    });
  }

  static searchChars(query: string): Promise<Array<string>> {
    return UniCloud._queryEndpoint(UNICLOUD_SEARCH_ENDPOINT, {p: 'name', q: query}).then((resp) => {
      const results: Array<string> = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const key in resp) {
        if (Object.hasOwn(resp, key)) {
          results.push(CharPickerData.helpers.fromCharCode(parseInt(key, 16)));
        }
      }
      return results;
    });
  }

  override state: UniCloudState = {name: undefined};

  private _isMounted: boolean = false;

  fetchName = (char: string): void => {
    this.setState({name: undefined});
    const charCode = CharPickerData.helpers.toCharCode(char).toString(16);
    UniCloud._queryEndpoint(UNICLOUD_PROPERTIES_ENDPOINT, {p: 'name', c: charCode})
      .then((resp): string => {
        // eslint-disable-next-line no-restricted-syntax, no-unreachable-loop
        for (const key in resp) {
          if (Object.hasOwn(resp, key)) {
            // Only expecting one, return the first one.
            const data = resp[key];
            return data.name;
          }
        }
        throw Error('Unexpected empty response', resp);
      })
      .catch(() => '\u00A0')
      .then((name) => {
        if (this._isMounted && this.props.char === char) {
          this.setState({name});
        }
      });
  };

  override componentDidMount(): void {
    this.fetchName(this.props.char);
    this._isMounted = true;
  }

  override componentWillUnmount(): void {
    this._isMounted = false;
  }

  override UNSAFE_componentWillReceiveProps(nextProps: UniCloudProps): void {
    if (nextProps.char !== this.props.char) {
      this.fetchName(nextProps.char);
    }
  }

  override render(): React.ReactNode {
    const codePoint = CharPickerData.helpers.toHexString(this.props.char);
    return this.props.children({name: this.state.name, codePoint});
  }
}

export default UniCloud;
